import React from "react"
import clsx from "clsx"
import DateHelper from "../../DateHelper/DateHelper";
import { parseISO } from 'date-fns';

class DocumentFormPresenterFormInformation extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {
    const form_started = typeof this.props.form_started == "string" ? parseISO(this.props.form_started) : this.props.form_started
    const form_completed = typeof this.props.form_completed == "string" ? parseISO(this.props.form_completed) : this.props.form_completed
    const tabClasses = clsx({
      'active': this.props.active_tab == 'signer_events',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id='signer_events'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='form-group'>
              <label className='control-label'>
                {I18n.t('started')}
              </label>
              <div>
                {DateHelper.printDateToScreen(form_started, this.props.date_format)} {I18n.t('at')} {DateHelper.printDateToScreen(form_started, this.props.time_format)}
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <div className='form-group'>
              <label className='control-label'>
                {I18n.t('completed')}
              </label>
              <div>
                {DateHelper.printDateToScreen(form_completed, this.props.date_format)} {I18n.t('at')} {DateHelper.printDateToScreen(form_completed, this.props.time_format)}
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <div className='form-group'>
              <label className='control-label'>
                {I18n.t('ip_address')}
              </label>
              <div>
                {this.props.customer_ip_address}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
    
  }

}

export default DocumentFormPresenterFormInformation